import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../api/axios";
import ProjectForm from "./ProjectForm";

function EditProject() {
  const { id } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const res = await API.get(`/projects/${id}`);
        setProject(res.data.data);
      } catch (err) {
        console.error("Error loading project:", err);
      }
    };

    fetchProject();
  }, [id]);

  return project ? (
    <ProjectForm project={project} />
  ) : (
    <div className="spinner-wrapper">
      <div className="spinner"></div>
    </div>
  );
}

export default EditProject;
